// Detección silenciosa de builds nuevas (silent update).
// Diseño completo: ../infra/docs/TODOs/260721-silent_frontend_updates.md
//
// Sondea /version.json (misma origin, Cache-Control: no-cache, publicado por
// el deploy) y lo compara con el sello de build que vue.config.js inyecta en
// el bundle. No recarga nada por sí mismo: solo enciende `updatePending` /
// `forcedUpdate`; la recarga ocurre en la próxima navegación (guard en
// main.js) o vía UpdateBanner en el caso forzado.
//
// FAIL-OPEN: ante cualquier error (red, JSON inválido, 404 → index.html con
// status 404) no se hace nada y la app sigue corriendo.
import { ref } from "vue";

const BUILD_ID = process.env.VUE_APP_BUILD_ID || "";
const BUILD_EPOCH = Number(process.env.VUE_APP_BUILD_EPOCH) || 0;

const EVENT_THROTTLE_MS = 5 * 60 * 1000; // checks disparados por focus/visible
const POLL_INTERVAL_MS = 15 * 60 * 1000; // poll lento de fondo

export const updatePending = ref(false);
export const forcedUpdate = ref(false);
export const remoteVersion = ref("");

let started = false;
let lastCheck = 0;

export async function checkNow() {
  // Build sin sello (no debería pasar post-B1): mecanismo deshabilitado.
  if (!BUILD_ID || !BUILD_EPOCH) return;
  lastCheck = Date.now();
  try {
    const res = await fetch("/version.json", {
      cache: "no-store",
      credentials: "omit",
    });
    if (!res.ok) return;
    const data = await res.json();
    if (!data || typeof data.version !== "string" || !Number.isFinite(data.epoch)) {
      return;
    }
    // Solo versiones DISTINTAS y más NUEVAS (epoch monótono): un rollback o
    // una edge cache desfasada nunca pueden provocar loops de recarga, y
    // re-deploys del mismo commit no recargan a nadie.
    if (data.version !== BUILD_ID && data.epoch > BUILD_EPOCH) {
      remoteVersion.value = data.version;
      updatePending.value = true;
      if (
        Number.isFinite(data.min_supported_epoch) &&
        data.min_supported_epoch > BUILD_EPOCH
      ) {
        forcedUpdate.value = true;
      }
    }
  } catch (e) {
    // fail-open
  }
}

function throttledCheck() {
  if (Date.now() - lastCheck >= EVENT_THROTTLE_MS) checkNow();
}

export function startVersionCheck() {
  if (started || !BUILD_ID || !BUILD_EPOCH) return;
  started = true;
  window.addEventListener("focus", throttledCheck);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") throttledCheck();
  });
  setInterval(checkNow, POLL_INTERVAL_MS);
}
